import { createResource } from '../../../shared/lib/createResource';
import { webgateFetch, WEBGATE_DOMAIN } from '../../../shared/lib/api';
import { useCurrentArtistId } from './useCurrentArtistId';
import { ArtistsPermissionsResponse } from './types'; // eslint-disable-line

const ArtistPermissionsResource = createResource(
  async function loadArtistPermissions(artistId: string) {
    const response = await webgateFetch(
      `${WEBGATE_DOMAIN}/s4x-me/v0/artists/${artistId}/permissions`,
    );

    if (response.status >= 500) {
      throw new Error(`${response.status} ${response.url}`);
    }

    if (response.status >= 400) {
      return [];
    }
    const { permissions } = await (response.json() as Promise<
      ArtistsPermissionsResponse
    >);

    return permissions;
  },
);

export function useCurrentArtistPermissions() {
  const artistId = useCurrentArtistId();
  return ArtistPermissionsResource.read(artistId);
}
